import { FC, useEffect } from 'react';
import isEmpty from 'lodash-es/isEmpty';
import { useFormContext } from 'react-hook-form';

import { WorkflowMirrorStepBlock } from '~/core/shared/types';

export const MirrorBlockRenderer: FC<WorkflowMirrorStepBlock> = ({
  originalField,
  mirrorTo,
}) => {
  const { watch, setValue, unregister } = useFormContext();

  const valueOrigin = watch(originalField);

  useEffect(() => {
    const shouldClear = valueOrigin === false || isEmpty(valueOrigin);

    if (shouldClear) {
      setValue(mirrorTo, undefined);
      unregister(mirrorTo);
    } else {
      setValue(mirrorTo, valueOrigin);
    }
  }, [setValue, unregister, mirrorTo, valueOrigin]);

  return null;
};
